// src/settingComponent/apiSetting/ApiAddCredits.jsx
import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { loadStripe } from '@stripe/stripe-js';
import './ApiAddCredits.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB_KEY);

const ApiAddCredits = ({ onClose, onAdd }) => {
  const [amount, setAmount] = useState(10);
  const [isLoading, setIsLoading] = useState(false);

  // slider min=10, max=950, step=10
  const isValid = amount >= 10 && amount <= 950 && amount % 10 === 0;

  // prepare callable
  const functions = getFunctions();
  const processCheckout = httpsCallable(functions, 'processCheckout');

  const handleSliderChange = e => {
    setAmount(parseInt(e.target.value, 10));
  };

  const handleContinue = async () => {
    if (!isValid) return;
    setIsLoading(true);

    const selectedQuantity = amount / 10;
    const payload = {
      selectedQuantity,
      purchaseType: 'api',
    };
    // console.log('processCheckout payload:', payload);

    try {
      const { data } = await processCheckout(payload);
      // console.log('processCheckout response:', data);
      // redirect to Stripe Checkout
      const stripe = await stripePromise;
      const { error } = await stripe.redirectToCheckout({ sessionId: data.id });
      if (error) {
        // console.error('Stripe redirect error:', error);
        // optionally show error to user
        setIsLoading(false);
      }
      // After successful redirect, checkout flow continues...
      // onAdd(amount); // credit details will update after webhook
    } catch (err) {
      // console.error('Error calling processCheckout:', err);
      setIsLoading(false);
    }
  };

  return (
    <div className="api-add-overlay">
      <div className="api-add-modal">
        <div className="api-add-header">
          <h2>Add to credit balance</h2>
          <button className="api-add-close" onClick={onClose}>&times;</button>
        </div>
        <div className="api-add-body">
          <div className="api-add-row">
            <div className="api-add-current">
              Amount: <strong>${amount}</strong>
            </div>
            <input
              type="range"
              className="api-add-slider"
              min="10"
              max="950"
              step="10"
              value={amount}
              onChange={handleSliderChange}
            />
            <div className="api-add-hint">
              Choose from $10 up to $950 in $10 increments
            </div>
          </div>
        </div>
        <div className="api-add-footer">
          <button className="api-cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button
            className="api-confirm-button"
            onClick={handleContinue}
            disabled={!isValid || isLoading}
          >
            {isLoading ? (
              <>
                <FontAwesomeIcon icon={faSpinner} spin className="loading-icon" />
                Loading…
              </>
            ) : (
              'Continue'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApiAddCredits;
